<template>
  <div>
    <DrawerContainer
      :dialogShow="dialogShow"
      :dialog-width="'65%'"
      title="订单详情"
      :has-footer="false"
      :wrapperClosable="true"
      @resetPopupData="dialogShow = false">
      <div class="order-detail custom-form" v-loading="loading">
        <address-template
          :showCancelOperate="false"
          :detail="detail"
        ></address-template>
        <cargo-template :detail="detail"></cargo-template>
        <third-order-template :detail="detail"></third-order-template>
        <order-status-step :details="detail"></order-status-step>
        <driver-template :detail="detail"></driver-template>
        <order-base-template :detail="detail"></order-base-template>
        <order-fee-template :detail="detail"></order-fee-template>
        <!--        <div class="title-box title-box-1">-->
        <!--          <div>-->
        <!--            <el-image :src="cheImage" class="title-label"></el-image>-->
        <!--            运输线路-->
        <!--          </div>-->
        <!--&lt;!&ndash;          <template v-if="showCancelBtn">&ndash;&gt;-->
        <!--&lt;!&ndash;            <el-button type="primary" @click="handleCancelOrder">取消订单</el-button>&ndash;&gt;-->
        <!--&lt;!&ndash;          </template>&ndash;&gt;-->

        <!--        </div>-->
        <!--        <div class="list-top">-->
        <!--          <div class="list-top-left">-->
        <!--            <div class="left-box" v-for="(item2, index) in detail.pointList" :key="index">-->
        <!--              <div class="left-box-top">-->
        <!--                <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">-->
        <!--                  {{ item2.loadType === 1 ? "装" : "卸" }}-->
        <!--                </div>-->
        <!--                <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>-->
        <!--                <div class="addresss">{{ item2.address }}</div>-->
        <!--                <div class="concact">联系人：{{ item2.linkUsername }}({{ item2.linkPhone }})</div>-->
        <!--              </div>-->
        <!--                <div class="date" v-if="index === 0">-->
        <!--                  <div>-->
        <!--                    装货时间：{{ detail.startLoadTime }}:00-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="title-box title-box1">-->
        <!--          <el-image :src="cheImage" class="title-label"></el-image>-->
        <!--          货物信息-->
        <!--        </div>-->

        <!--        <div class="list-box">-->
        <!--          <div class="list-bottom">-->
        <!--            <div class="list-bottom-box  list-bottom-box-1">-->
        <!--              <div class="bottom-box-name">物品</div>-->
        <!--              <div class="bottom-box-value">-->
        <!--                <custom-tooltip :text="detail?.cargo?.cargoName"></custom-tooltip>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="list-bottom-box  list-bottom-box-1">-->
        <!--              <div class="bottom-box-name">重量</div>-->
        <!--              <div class="bottom-box-value">-->
        <!--                {{ detail?.cargo?.weight || "-" }}-->
        <!--                {{ detail?.cargo?.wightUnit === 1 ? "吨" : "公斤" }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="list-bottom-box  list-bottom-box-1">-->
        <!--              <div class="bottom-box-name">体积</div>-->
        <!--              <div class="bottom-box-value">{{ detail?.cargo?.volume || "-" }}㎡</div>-->
        <!--            </div>-->
        <!--            <div class="list-bottom-box  list-bottom-box-1">-->
        <!--              <div class="bottom-box-name">包装方式</div>-->
        <!--              <div class="bottom-box-value">-->
        <!--                {{ detail?.cargo?.packingWays || "-" }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="list-bottom-box  list-bottom-box-1">-->
        <!--              <div class="bottom-box-name">发票</div>-->
        <!--              <div class="bottom-box-value">-->
        <!--                {{ detail.needInvoice ? "需要" : "不需要" }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--&lt;!&ndash;            <div class="list-bottom-box">&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-name">用车要求</div>&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-value">&ndash;&gt;-->
        <!--&lt;!&ndash;                {{ detail?.vehicleUseType || "-" }}&ndash;&gt;-->
        <!--&lt;!&ndash;              </div>&ndash;&gt;-->
        <!--&lt;!&ndash;            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;            <div class="list-bottom-box">&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-name">车型</div>&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-value">&ndash;&gt;-->
        <!--&lt;!&ndash;                <custom-tooltip-multiple :text="detail?.vehicle?.vehicleMode"></custom-tooltip-multiple>&ndash;&gt;-->
        <!--&lt;!&ndash;              </div>&ndash;&gt;-->
        <!--&lt;!&ndash;            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;            <div class="list-bottom-box">&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-name">车长</div>&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-value">&ndash;&gt;-->
        <!--&lt;!&ndash;                <custom-tooltip-multiple :text="detail?.vehicle?.vehicleLength"></custom-tooltip-multiple>&ndash;&gt;-->
        <!--&lt;!&ndash;              </div>&ndash;&gt;-->
        <!--&lt;!&ndash;            </div>&ndash;&gt;-->
        <!--          </div>-->
        <!--          <div class="list-bottom">-->

        <!--&lt;!&ndash;            <div class="list-bottom-box">&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-name">公里数</div>&ndash;&gt;-->
        <!--&lt;!&ndash;              <div class="bottom-box-value">{{ detail.kilometre || "-" }}km</div>&ndash;&gt;-->
        <!--&lt;!&ndash;            </div>&ndash;&gt;-->

        <!--            <div class="list-bottom-box  list-bottom-box-1">-->
        <!--              <div class="bottom-box-name">回单</div>-->
        <!--              <div class="bottom-box-value">-->
        <!--                {{ getLocalLabel("receiptType", detail.receiptType) }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="list-bottom-box list-bottom-box-2" v-if="detail.remark">-->
        <!--              <div class="bottom-box-name">备注</div>-->
        <!--              <div class="bottom-box-value bottom-box-value2">-->
        <!--                <custom-tooltip :text="detail.remark"></custom-tooltip>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="list-bottom-image">-->
        <!--            <div class="list-bottom">-->
        <!--              <div class="list-bottom-box" v-for="(item, index) in detail?.cargo?.pictures" :key="index">-->
        <!--                <el-image :src="getFileUrl(item)" class="list-image" :preview-src-list="[getFileUrl(item)]"></el-image>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="list-status">-->
        <!--          <div class="list-carInfo">-->
        <!--            <template v-if="detail.orderSource === 2">-->
        <!--              <div class="title-box">-->
        <!--                <el-image :src="cheImage" class="title-label"></el-image>-->
        <!--                第三方订单信息-->
        <!--              </div>-->

        <!--              <div class="list-box">-->
        <!--                <div class="list-bottom">-->
        <!--                  <div class="list-bottom-box list-bottom-box2">-->
        <!--                    <div class="bottom-box-name">订单类型</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      {{ detail?.orderType || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box list-bottom-box2">-->
        <!--                    <div class="bottom-box-name">运费</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      ￥{{ detail?.fee }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box list-bottom-box2">-->
        <!--                    <div class="bottom-box-name">技术服务费</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      ￥{{ detail?.technicalFee }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box list-bottom-box2">-->
        <!--                    <div class="bottom-box-name">订金</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      ￥{{ detail?.deposit }}{{detail.canRefund?'（可退）':'（不可退）'}}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box list-bottom-box2">-->
        <!--                    <div class="bottom-box-name">订单编号</div>-->
        <!--                    <div class="bottom-box-value color1269FF">-->
        <!--                      {{ detail?.sourceOrderNo || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </template>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="list-status">-->
        <!--          <div class="list-carInfo">-->
        <!--            <order-status-step :details="detail"></order-status-step>-->
        <!--            <template v-if="detail?.driver">-->
        <!--              <div class="title-box">-->
        <!--                <el-image :src="cheImage" class="title-label"></el-image>-->
        <!--                承运信息-->
        <!--              </div>-->

        <!--              <div class="list-box">-->
        <!--                <div class="list-bottom">-->
        <!--                  <div class="list-bottom-box">-->
        <!--                    <el-image :src="siJiImage" class="siji-image"></el-image>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box">-->
        <!--                    <div class="bottom-box-name">司机姓名</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      {{ detail?.driver?.username || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box list-bottom-box2">-->
        <!--                    <div class="bottom-box-name">联系电话</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      {{ detail?.driver?.phone || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box">-->
        <!--                    <div class="bottom-box-name">车牌号码</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      {{ detail?.driver?.carNumber || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box">-->
        <!--                    <div class="bottom-box-name">所属服务商</div>-->
        <!--                    <div class="bottom-box-value">-->
        <!--                      {{ detail?.driver?.companyName || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box">-->
        <!--                    <div class="bottom-box-name">关联车队长</div>-->
        <!--                    <div class="bottom-box-value color1269FF">-->
        <!--                      <custom-tooltip :text="detail?.driver?.vehicleLeaderName"></custom-tooltip>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                  <div class="list-bottom-box">-->
        <!--                    <div class="bottom-box-name">责任调度</div>-->
        <!--                    <div class="bottom-box-value color1269FF">-->
        <!--                      {{ detail?.driver?.dispatcherName || "-" }}-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </template>-->
        <!--            <div class="title-box">-->
        <!--              <el-image :src="cheImage" class="title-label"></el-image>-->
        <!--              订单基础信息-->
        <!--            </div>-->
        <!--            <div class="list-box list-box3">-->
        <!--              <div class="list-bottom">-->
        <!--                <div class="list-bottom-box list-bottom-box-1">-->
        <!--                  <el-image :src="dngDanImage" class="ding-image"></el-image>-->
        <!--                </div>-->
        <!--                <div class="list-bottom-box">-->
        <!--                  <div class="bottom-box-name">发货方</div>-->
        <!--                  <div class="bottom-box-value">-->
        <!--                    <custom-tooltip :text="detail?.companyName"></custom-tooltip>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div class="list-bottom-box">-->
        <!--                  <div class="bottom-box-name">发货人姓名</div>-->
        <!--                  <div class="bottom-box-value">-->
        <!--                    <custom-tooltip :text="detail?.ownerName"></custom-tooltip>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div class="list-bottom-box">-->
        <!--                  <div class="bottom-box-name">联系方式</div>-->
        <!--                  <div class="bottom-box-value">-->
        <!--                    <custom-tooltip :text="detail?.ownerPhone"></custom-tooltip>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div class="list-bottom-box">-->
        <!--                  <div class="bottom-box-name">下单方式</div>-->
        <!--                  <div class="bottom-box-value">-->
        <!--                    {{ getLocalLabel("orderFrom", detail?.orderFrom) || "-" }}-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div class="list-bottom-box">-->
        <!--                  <div class="bottom-box-name">订单编号</div>-->
        <!--                  <div class="bottom-box-value">-->
        <!--                    {{detail.orderNo}}-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <template v-if="detail.orderSource === 1">-->
        <!--              <div class="title-box">-->
        <!--                <el-image :src="cheImage" class="title-label"></el-image>-->
        <!--                订单收费明细信息-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <div class="title-box">-->
        <!--                  客户支付价格：-->
        <!--                  <span class="price color526bec">{{ detail.payableFee }}元</span>-->
        <!--                </div>-->
        <!--                <el-row class="price-des-box">-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">初始运单价格：</span>-->
        <!--                    <span class="value">￥{{ detail.sourceFee }}</span>-->
        <!--                  </el-col>-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">优惠/加价后价格：</span>-->
        <!--                    <span class="value">￥{{ detail.fee }}</span>-->
        <!--                  </el-col>-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">代理商运营费：</span>-->
        <!--                    <span class="value">￥{{ detail.agentFee }}</span>-->
        <!--                  </el-col>-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">发票价格：</span>-->
        <!--                    <span class="value">￥{{ detail.invoiceFee }}</span>-->
        <!--                  </el-col>-->
        <!--                </el-row>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <div class="title-box">-->
        <!--                  司机运费：-->
        <!--                  <span class="price color526bec">{{ detail.driverFee }}元</span>-->
        <!--                </div>-->
        <!--                <el-row class="price-des-box">-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">初始运单价格：</span>-->
        <!--                    <span class="value">￥{{ detail.sourceFee }}</span>-->
        <!--                  </el-col>-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">优惠/加价后价格：</span>-->
        <!--                    <span class="value">￥{{ detail.fee }}</span>-->
        <!--                  </el-col>-->
        <!--                  <el-col :span="12" class="label-val">-->
        <!--                    <span class="label">服务商运营费：</span>-->
        <!--                    <span class="value">￥{{ detail.platformCommissionFee }}</span>-->
        <!--                  </el-col>-->
        <!--                </el-row>-->
        <!--              </div>-->

        <!--            </template>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </DrawerContainer>
  </div>
</template>
<script>
import DrawerContainer from "@/components/Drawer.vue";
import orderStatusStep from "@/components/orderStatusStep.vue";
import { detailInfo } from "@/views/SchedulingWorkbench/OrderReassignment/api";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import { getLocalLabel } from "@/utils/localDict";
import detail from "./stepDetail.vue";

import { getFileUrl } from "@/utils/tool";
import { resetPassword } from "@/views/SystemManagement/AgentManagement/api";
import { cancelOrder } from "@/views/OrderManagement/api";
import DriverTemplate from "@/components/customComponents/driverTemplate.vue";
import AddressTemplate from "@/components/customComponents/addressTemplate.vue";
import OrderBaseTemplate from "@/components/customComponents/orderBaseTemplate.vue";
import ThirdOrderTemplate from "@/components/customComponents/thirdOrderTemplate.vue";
import CargoTemplate from "@/components/customComponents/cargoTemplate.vue";
import OrderFeeTemplate from "@/components/customComponents/orderFeeTemplate.vue";
export default {
  name: "AddOrEdit",
  data() {
    return {
      getFileUrl,
      loading: false,
      detailImage: require("@/assets/imgs/bg.png"),
      cheImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
      dialogShow: false,
      detail: {},
      stepData: [
        {
          date: "2025-20-11 10:22:11",
          content: "司机结单",
          isOver: false,
        },
        {
          date: "2025-20-11 10:22:11",
          content: "装货途经点装货",
          isOver: false,
        },
        {
          date: "2025-20-11 10:22:11",
          content: "卸货途经点卸货",
          isOver: false,
        },
        {
          date: "2025-20-11 10:22:11",
          content: "卸货途经点卸货",
          isOver: false,
        },
      ],
    };
  },
  components: {
    OrderFeeTemplate, CargoTemplate, ThirdOrderTemplate, OrderBaseTemplate,
    AddressTemplate, DriverTemplate,
    CustomTooltipMultiple,
    CustomTooltip,
    orderStatusStep,
    detail,
    DrawerContainer,
  },
  computed: {
    showCancelBtn: function () {
      let b = false
      // 之前逻辑取消， 现在改成只要不是已完成和已取消，都给他展示出来，反正他们现在是后台审核 不是-1和100，都可以取消
      // if (this.detail.orderSource === 2) {
      //   b = false
      // } else {
      //
      //   if (this.detail.orderStatus === 0) {
      //     // 取消状态
      //     b = false
      //   } else if (this.detail.orderStatus === 1 || this.detail.orderStatus === 10) {
      //     // 1待支付，10待派单
      //     b = true
      //   } else if (this.detail.orderStatus === 20) {
      //     // 进行中
      //
      //     if (this.driverToZhd()) {
      //       // 如果起点装货没装 还可以取消
      //       b = true
      //     }
      //   } else {
      //     b = false
      //   }
      // }
      // return b
      if (this.detail.orderSource === -1 || this.detail.orderSource === 100) {
        b = false
      } else {
        b = true
      }
      return b
    }
  },
  methods: {
    getLocalLabel,
    driverToZhd() {
      let status = false
      let arr = [...this.detail.pointList]
      if (arr && arr.length > 0) {
        if (arr[0].completeStatus === 0) {
          status = true
        }
      }
      return status
    },
    handleCheckDetail(item) {
      this.$refs.detail.init(item);
    },
    isCheckDetail(stepStatus, stepType) {
      // 1货主下单，2客服代下单，5货主支付，10调度派单，11订单改派，21装货点装货，22卸货点卸货，31订单取消，41订单退款
      let arr = [5, 10, 11, 21, 22, 31, 41];
      if (stepStatus === 0) {
        return false;
      } else {
        if (arr.includes(stepType)) {
          return true;
        }
        return false;
      }
    },
    init(row) {
      this.orderId = row.orderId;
      this.getOrderDetail(row.orderId);

      this.dialogShow = true;
    },
    handleCancelOrder() {
      this.$confirm(`确定取消当前订单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        cancelOrder({ orderId: this.orderId }).then((res) => {
          if (res.code === 200) {
            this.$message.success("订单取消成功");
            this.$emit("refresh")
            this.dialogShow = false
            this.orderId = ""

          }
        });
      });
    },
    getOrderDetail(orderId) {
      this.loading = true;
      detailInfo(orderId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.detail = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  padding: 0 0.16rem 0.2rem;
  box-sizing: border-box;
  .list-top {
    display: flex;
    justify-content: space-between;
    padding-left: 0.4rem;
    margin-top: 0.2rem;
    .list-top-left {
      .left-box {
        padding-right: 0.5rem;
        position: relative;
        margin-bottom: 0.4rem;
        .left-box-top {
          display: flex;
          align-items: center;
          .label {
            width: 0.2rem;
            height: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.02rem;
            font-size: 0.12rem;
          }
          .zhuang {
            color: #5cc41a;
            background-color: rgba(92, 196, 26, 0.3);
          }
          .xie {
            color: #e52019;
            background-color: rgba(229, 32, 25, 0.3);
          }
          .name {
            color: #000000;
            font-size: 0.18rem;
            line-height: 0.2rem;
            padding-left: 0.04rem;
          }
          .addresss {
            color: #000000;
            font-size: 0.16rem;
            line-height: 0.2rem;
            padding-left: 0.2rem;
            min-width: 3rem;
          }
          .concact {
            color: #666666;
            font-size: 0.16rem;
            line-height: 0.2rem;
            padding-left: 0.2rem;
          }
        }
        .date {
          color: #8c8c8c;
          font-size: 0.14rem;
          line-height: 0.2rem;
          position: absolute;
          top: 0.26rem;
          left: 0.26rem;
        }
      }
      .left-box::before {
        content: "→";
        position: absolute;
        left: 0rem;
        top: 0.3rem;
        font-size: 0.2rem;
        color: #52c41a;
        transform: rotate(90deg);
      }
      .left-box:nth-last-of-type(1)::before {
        display: none;
      }
      .left-box:nth-last-of-type(1) {
        margin-bottom: 0.4rem;
      }
    }
    .list-top-right {
      .right-ding {
        font-size: 0.14rem;
        padding-top: 0.06rem;
      }
      .right-money {
        display: flex;
        justify-content: right;
        align-items: baseline;
        color: #faad14;
        .money {
          font-size: 0.18rem;
        }
        .unit {
          font-size: 0.12rem;
          padding-left: 0.04rem;
        }
      }
      .right-box2 {
        display: flex;
        align-items: center;
        .right-box2-time {
          font-size: 0.12rem;
          line-height: 0.2rem;
          color: #8c8c8c;
          margin-right: 0.1rem;
        }
        .right-box2-label {
          background-color: #fff7e6;
          color: #fa8c16;
          font-size: 0.12rem;
          line-height: 0.22rem;
          border-radius: 0.1rem;
          padding: 0 0.1rem;
        }
      }
    }
  }
  .list-box {
    background: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    .list-bottom-image {
      .list-bottom {
        padding-left: 0.5rem;
        .list-bottom-box {
          width: auto !important;
          padding-right: 0.1rem;
        }
        .list-bottom-box:before {
          display: none;
        }
      }
    }
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.08rem 0;

      .list-bottom-box {
        width: 14%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .list-image {
          width: 0.85rem;
          height: 0.85rem;
          border-radius: 0.05rem;
        }
        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.12rem;
          margin-bottom: 0.06rem;
        }
        .bottom-box-value {
          color: #434343;
          font-size: 0.14rem;
          text-align: center;
        }
      }
      .list-bottom-box-1{
        width: 20%;
      }
      .list-bottom-box-2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        position: relative;
        width: 80%;
        padding-left: 0.2rem;
        .bottom-box-value2 {
          text-align: left;
        }
      }
      .list-bottom-box2 {
        width: 20%;
      }
      .list-bottom-box4 {
        width: 30%;
      }
      .list-bottom-box3 {
        width: 40%;
        padding-left: 0.1rem;
        .bottom-box-name {
          width: 100%;
        }
        .bottom-box-value2 {
          text-align: left;
        }
      }
      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.08rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }
      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
    }
    .list-bottom2 {
      .list-bottom-box:nth-last-of-type(1):before {
        display: none;
      }
    }
  }
  .list-box3 {
    .list-bottom {
      .list-bottom-box {
        width: 18%;
      }
      .list-bottom-box-1 {
        width: 8%;
      }
    }
  }
  .list-box1 {
    margin-top: 0 !important;
    .list-bottom-box {
      width: 25% !important;
    }
  }
  .list-status {
    display: flex;
    .title-box {
      padding: 0.2rem 0 0;
      .title-label {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.06rem;
      }
    }
    .list-carInfo {
      width: 100%;
    }
    .list-label {
      padding: 0.1rem 0;
    }
    .color8c8c8c {
      color: #8c8c8c;
    }
    .color434343 {
      color: #434343;
    }
    .bgEDF4FF {
      background-color: #edf4ff;
    }
  }
  .siji-image,
  .ding-image {
    width: 0.2rem;
    height: 0.2rem;
  }
  .title-box1{
    margin-top: -0.1rem;
  }
  .title-box-1{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.price-des-box{
  background-color: #F7FBFF;
  padding-top: 0.1rem;
  padding-left: 0.1rem;
  border-radius: 5px;
  margin-top: 0.1rem;
}
.price{
  font-size: 0.18rem;
}
.label-val {
  margin-bottom: 0.16rem;
  .label{
    width: 1.2rem;
    text-align: right;
  }
}
.label-val{
  .label{
    color: #000000;
  }
  .value{
    color: #0a65f0;
    font-size: 0.18rem;
  }
}
</style>
